import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseCatalogueSearch } from '../models/course-catalogue-search';
import { ApiConstants } from '../../shared/constants/api-constants';
import { Observable, of, tap } from 'rxjs';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { BaseSearchRequest } from '../../shared/models/search/base-search-request';
import { SearchMapperService } from '../../shared/services/search-mapper.service';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';


@Injectable({
  providedIn: 'root'
})
export class CourseCatalogueService {
  eQMSScopesForCourseSearch: IEQMSScopeLookUpDetails[] = [];
  constructor(private httpClient: HttpClient, private searchMapper: SearchMapperService) { }
  
  getCourseCatalogueSearch(courseCatalogueSearchCriteria: CourseCatalogueSearch,
     paginationState : PaginationState | null,
         filters?: AppliedFilters | null,
         sort?: SortCriteria | null): Observable<any> {
      const base: BaseSearchRequest = this.searchMapper.mapToBaseSearchRequest(filters, sort, paginationState);
      let payload = {
        ...courseCatalogueSearchCriteria,
        ...base
      };
      return this.httpClient.post(
      ApiConstants.Course_Catalogue_Search_Api, payload);
  }

  geteQMSScopesForCourseSearch = (feature:string) => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForCourseSearch.length > 0) {
      observable = of(this.eQMSScopesForCourseSearch);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>(ApiConstants.EQMSScopesLookupForCourseLibrary_Api + "/" + feature)
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForCourseSearch = eQMSScopes)
        );
    }
    return observable;
  }
  
}
